import React from 'react';

const PRODUCTS = [
  { name: "Extrait de Parfum", img: "/Product maklon/Extrait De Parfum.png" },
  { name: "Eau De Parfum (EDP)", img: "/Product maklon/Eau De Parfume.png" },
  { name: "Eau De Toilette (EDT)", img: "/Product maklon/Eau De Toilete.png" },
  { name: "Hair & Body Mist", img: "/Product maklon/Hair & Body Mist.png" },
  { name: "Discovery Set", img: "/Product maklon/Discovery Set.png" },
  { name: "Reed Diffuser", img: "/Product maklon/Reed Difuser.png" }
];

export default function ProductTypesSection({ title, subtitle }) {
  return (
    <section className="py-12 md:py-20 px-6 lg:px-12 bg-white" data-aos="fade-up">
      <div className="container mx-auto max-w-6xl text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-[#302621] mb-3 md:mb-4">{title}</h2>
        {subtitle && <p className="text-sm md:text-base text-[#7A695B] mb-8 md:mb-12 max-w-2xl mx-auto">{subtitle}</p>}
        {!subtitle && <div className="mb-8 md:mb-12"></div>}
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-6 justify-items-center">
          {PRODUCTS.map((prod, idx) => (
            <div key={idx} className="flex flex-col items-center w-full">
              <div className="w-full aspect-square bg-[#FCFAF6] border border-[#E6D5B8]/40 rounded-2xl overflow-hidden mb-3 md:mb-4 hover:border-[#D4AF37] transition-colors cursor-pointer group shadow-sm relative">
                <img src={prod.img} alt={prod.name} className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
              </div>
              <h4 className="font-bold text-[#302621] text-[10px] md:text-sm text-center px-2">{prod.name}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
